import { useMutation, useQuery } from '@tanstack/react-query'
import { getPets, updatePet } from '@/services/pets.services'
import type { PetUpdateBody } from '@/services/pets.services'
import type { Pet } from '@/shared/types/global.types'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import {
  PAYMENT_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import { queryClient } from '@/shared/lib/tanstack'

export function usePets(enabled: boolean = true) {
  const queryKey = PAYMENT_QUERY_KEYS.pets

  const invalidatePets = () => queryClient.invalidateQueries({ queryKey })

  const query = useQuery<Pet[]>({
    queryKey,
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getPets(token)
    },
    enabled,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })

  const updateMutation = useMutation({
    mutationFn: ({ id, body }: { id: number; body: PetUpdateBody }) =>
      updatePet(id, body),
    onSuccess: invalidatePets,
    onError: console.error,
  })

  return { ...query, updateMutation }
}
